import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./SignIn.module.css";
import { singInRequest } from "./api/index";
import { useAuth } from "../../context/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { useIntl } from "react-intl";
import logo from "../../assets/logo.png";
export const SignIn = () => {
  const intl = useIntl();

  const navigate = useNavigate();
  const { onLogin, googleAuth, isLoading } = useAuth();

  const [type, setType] = useState("password");
  const [icon, setIcon] = useState(faEyeSlash);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [visible, setVisible] = useState(false);
  const handleToggle = () => {
    if (type === "password") {
      setIcon(faEye);
      setType("text");
    } else {
      setIcon(faEyeSlash);
      setType("password");
    }
  };

  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    if (error) {
      setError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setError("");
      const data = await onLogin(formData);
      console.log("Login data:", data);

      await singInRequest(formData);
      navigate("/home");
    } catch (error) {
      console.error("Sign in error:", error);
      setError(error.message || "");
    }
  };

  const handleGoogleSignIn = async () => {
    try {
      setError("");
      console.log("Google sign in clicked");
    } catch (error) {
      console.error("Google sign in error:", error);
      setError("Google մուտքի սխալ");
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.formContainer}>
        <div className={styles.header}>
          <Link to="/" className={styles.logo}>
            {/* viewStruct */}
            <img src={logo} alt="viewStruct logo" srcset="" />
          </Link>
          <h1 className={styles.title}>
            {intl.formatMessage({ id: "signInId1" })}
          </h1>
          <p className={styles.subtitle}>
            {" "}
            {intl.formatMessage({ id: "signInId2" })}
          </p>
        </div>

        {/* {error && <div className={styles.error}>{error}</div>} */}

        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.inputGroup}>
            <label htmlFor="email" className={styles.label}>
              {intl.formatMessage({ id: "signInId3" })}
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={styles.input}
              placeholder={intl.formatMessage({ id: "signInId4" })}
              required
              disabled={isLoading}
            />
          </div>
          {/* password  */}
          {/* <div className={styles.inputGroup}>
            <label htmlFor="password" className={styles.label}>
              Password
            </label>
            <input
              id="password"
              name="password"
              type={type}
              value={formData.password}
              onChange={handleChange}
              className={styles.input}
              placeholder="Enter your password"
              required
              disabled={isLoading}
            />
            <span className={styles.eyeBox} onClick={handleToggle}>
              <FontAwesomeIcon icon={icon} />
            </span>
          </div> */}
          {/* end password */}

          <div className={styles.wrapper}>
            <input
              id="password"
              name="password"
              type={visible ? "text" : "password"}
              placeholder={intl.formatMessage({ id: "signInId5" })}
              className={styles.input}
              value={formData.password}
              onChange={handleChange}
              required
              disabled={isLoading}
            />
            <button
              type="button"
              className={styles.eyeBtn}
              onClick={() => setVisible(!visible)}
              aria-label={visible ? "Hide password" : "Show password"}
            >
              {visible ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className={styles.eyeIcon}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M1.5 12s4.5-7.5 10.5-7.5S22.5 12 22.5 12s-4.5 7.5-10.5 7.5S1.5 12 1.5 12z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className={styles.eyeIcon}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M17.94 17.94A10.97 10.97 0 0 1 12 19.5C6 19.5 1.5 12 1.5 12a21.3 21.3 0 0 1 5.04-5.94M9.9 9.9A3 3 0 0 1 14.1 14.1M3 3l18 18" />
                </svg>
              )}
            </button>
          </div>
          {/* <div className={styles.options}>
            <label className={styles.checkbox}>
              <input type="checkbox" disabled={isLoading} />
              <span className={styles.checkmark}></span>
              {intl.formatMessage({ id: "signInId6" })}
            </label>
            <a href="#" className={styles.forgotPassword}>
              {intl.formatMessage({ id: "signInId7" })}
            </a>
          </div> */}

          <button
            type="submit"
            className={styles.submitBtn}
            disabled={isLoading}
          >
            {isLoading
              ? intl.formatMessage({ id: "signInId8" })
              : intl.formatMessage({ id: "signInId9" })}
          </button>
        </form>
        {/* 
        <div className={styles.divider}>
          <span>or</span>
        </div> */}

        <div className={styles.socialButtons}>
          {/* <button
            className={styles.socialBtn}
            onClick={handleGoogleSignIn}
            disabled={isLoading}
            type="button"
          >
            <span>Continue with Google</span>
          </button> */}
          {/* <button
            className={styles.socialBtn}
            disabled={isLoading}
            type="button"
          >
            <span>Continue with Microsoft</span>
          </button> */}
        </div>

        {/* <p className={styles.signupPrompt}>
          {intl.formatMessage({ id: "signInId10" })}

          <Link to="/signup" className={styles.signupLink}>
            {intl.formatMessage({ id: "signInId11" })}
          </Link>
        </p> */}
      </div>

      <div className={styles.backgroundDecoration}>
        <div className={styles.shape1}></div>
        <div className={styles.shape2}></div>
        <div className={styles.shape3}></div>
      </div>
    </div>
  );
};
